/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

import WifiIcon from '@/assets/icons/SystemSettingsWifi.svg';
import WifiDisableIcon from '@/assets/icons/SystemSettingsWifiDisable.svg';
import WifiNotConnectedIcon from '@/assets/icons/SystemSettingsWifiNotConnected.svg';
import {proteinConcentrationColor} from '@/constants/appStyle';
import {WIFI_STATUS, WIFI_SETTING, WIFI_SETTING_ADDRESS_WITHOUT_HASH} from '@/constants/pcConstAppData';
import {useWifiStatusContext} from '@/contexts/WifiStatusContext';

function WifiButton(props) {
  const {wifiIcon} = props;

  const WifiButtonStyle = css({
    height: '70px',
    color: 'inherit',
    marginRight: '25px',
    backgroundColor: 'transparent',
    border: 'none',

    '.wifi-icon': {
      width: '63px',
      margin: '0',
    },

    ':disabled': {
      color: `fade(${proteinConcentrationColor}, 25%)`,
    },
  });

  return (
    <Link
      css={WifiButtonStyle}
      id={WIFI_SETTING}
      to={WIFI_SETTING_ADDRESS_WITHOUT_HASH}
      replace
    >
      <img
        className="wifi-icon"
        src={wifiIcon}
        alt={wifiIcon}
      />
    </Link>
  );
}
WifiButton.propTypes = {
  wifiIcon: PropTypes.any.isRequired,
};

function WifiStatusButton() {
  const {wifiStatus} = useWifiStatusContext();

  switch (wifiStatus) {
    case WIFI_STATUS.CONNECTED:
      return <WifiButton wifiIcon={WifiIcon} />;
    case WIFI_STATUS.ON:
      return <WifiButton wifiIcon={WifiNotConnectedIcon} />;
    case WIFI_STATUS.OFF:
      return <WifiButton wifiIcon={WifiDisableIcon} />;
    default:
      break;
  }
}
export default WifiStatusButton;
